import { ComputedDataKey } from "../../constants";
import { TestResolver } from "../../models";

export const exclusivePriceAddition: TestResolver = ({
  context,
  validationAdditional,
  value,
  errorMessage,
}) => {
  const exclusiveAdditionsIds =
    context.parent?.[ComputedDataKey]?.exclusiveAdditionsIds ?? [];

  if (!value || !exclusiveAdditionsIds?.length) {
    return true;
  }

  const isHasOnlyOneAdditionChosen = Array.isArray(value) && value.length <= 1;
  const exclusiveAdditionsIdsSet = new Set(exclusiveAdditionsIds);
  const isAllChosenAdditionIsNotExclusive =
    Array.isArray(value) &&
    value.every(addition => !exclusiveAdditionsIdsSet.has(addition));

  if (isHasOnlyOneAdditionChosen || isAllChosenAdditionIsNotExclusive) {
    return true;
  }

  return context.createError({ message: errorMessage, path: context.path });
};
